// @flow
export { default } from "./CentredHero";
